export default function TripTravellerAllocationService(
    $http,
    tripTravellerAllocationFlightService,
) {
    'ngInject';

    Object.assign(this, {
        prepareSeats,
        addNonSelectedSeats,
        restoreSelectedFfn,
        saveSeats,
    });

    function prepareSeats(tripDetails) {
        return tripDetails.Flights.reduce((accumulator, flightRecommendation) => ({
            ...accumulator,
            ...flightRecommendation.FlightGroups
                .reduce(transformFlightGroup, {}),
        }), {});

        function transformFlightGroup(accumulator, group) {
            return {
                ...accumulator,
                ...group.Flights
                    .reduce(transformFlights, {}),
            };
        }

        function transformFlights(accumulator, flight) {
            return {
                ...accumulator,
                [flight.Id]: flight.FlightPassengers
                    .reduce(transformFlightPassengers, {}),
            };
        }

        function transformFlightPassengers(accumulator, passenger) {
            const {TripPassengerId} = passenger;
            return {
                ...accumulator,
                [TripPassengerId]: {...passenger},
            };
        }
    }

    function addNonSelectedSeats(seats, tripDetails) {
        const travellers = tripTravellerAllocationFlightService.getTravellersWhichAreAllowedToSelectSeat(tripDetails);
        const travellersId = travellers
            .map(({Id}) => Id)
            .filter((id) => !!id)
            .reduce((accumulator, passengerId) => ({
                ...accumulator,
                [passengerId]: {TripPassengerId: passengerId},
            }), {});

        Object.keys(seats).forEach((flightId) => {
            seats[flightId] = {
                ...angular.copy(travellersId),
                ...seats[flightId],
            };
        });

        return seats;
    }

    function restoreSelectedFfn(newSelectedSeats, oldSelectedSeats) {
        Object.entries(newSelectedSeats).forEach(([flightId, selected]) => {
            Object.entries(selected).forEach(([travellerId, selectionModel]) => {
                if (selectionModel.SeatNumber) {
                    return;
                }
                const old = oldSelectedSeats[flightId][travellerId];
                if (old && old.TravellerClubCardId) {
                    const {TravellerClubCardId, Ffn, SupplierCode, SupplierName} = old;
                    Object.assign(selectionModel, {
                        TravellerClubCardId,
                        Ffn,
                        SupplierCode,
                        SupplierName,
                    });
                }
            });
        });
        return newSelectedSeats;
    }

    function saveSeats(selectedSeats) {
        const transformedSeats = transformSelectedSeats(selectedSeats);
        const saveSeatsUrl = '/trips/SaveSeatSelection';
        return $http.apiPOST(saveSeatsUrl, transformedSeats);
    }

    function transformSelectedSeats(selectedSeats) {
        return {
            Flights: Object.keys(selectedSeats).map((flightId) => ({
                TripItemFlightId: +flightId,
                Seats: Object.keys(selectedSeats[flightId]).map((travellerId) => {
                    const value = selectedSeats[flightId][travellerId];
                    return {
                        TripPassengerId: +travellerId,
                        TravellerClubCardId: value.TravellerClubCardId,
                        SeatNumber: value.SeatNumber,
                        SeatPrice: value.SeatPrice,
                        SeatPosition: value.SeatPosition,
                    };
                }),
            })),
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-service.js